<template>
  <v-app>
    <v-overlay v-if="isLoading.main" color="rgba(0,0,0,0.4)">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
    <router-view v-if="!isLoading.main" />
  </v-app>
</template>

<script>
import config from './configs'
import { mapState, mapGetters } from 'vuex'

export default {
  data() {
    return {
      isActive: true // Default true, will be updated
    }
  },
  computed: {
    ...mapState({
      isLoading: (state) => state.microsite.isLoading,
      meta: (state) => state.microsite.meta // Get meta attributes
    }),
    ...mapGetters({
      theme: 'microsite/theme'
    })
  },
  created() {
    // Check if active is 0 and stop app

    console.log(this.meta)

    if (this.meta?.Active === 0) {
      console.warn('App is inactive. Aborting...')
      this.isActive = false // Hide app content
      this.$router.replace('/inactive') // Optional: Redirect to a custom error page
    }

    // Apply theme colors
    this.$vuetify.theme.themes.light.primary = this.theme.primary
    this.$vuetify.theme.themes.light.secondary = this.theme.secondary
  },
  head: {
    link: [
      ...config.icons.map((href) => ({ rel: 'stylesheet', href }))
    ]
  }
}
</script>
